export const isObject = <T>(object: T): boolean => {
  return object != null && typeof object === 'object';
};
